import React from "react";
import { COLOR_BLUE_BAYOUX } from "../../constants/styles";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { Table } from "../../UI/Table";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import NoResults from "../../common/component/NoResults";
import { UserSearchResultsTableBody } from "./UserSearchResultsTableBody";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";

interface IProps {
  results: any[];
  isGlobalSearch: boolean;
}

export const UserSearchResultsTable: React.FC<IProps> = (props) => {
  const { isOpen, isPasscode } = useSelectedNetworkImportTypes();

  const isNotImportDate = isOpen || isPasscode;

  return (
    <>
      {!!props.results.length && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color={COLOR_BLUE_BAYOUX}>
              {props.results.length} user(s) found
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Table padding="checkbox">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Matching Round</TableCell>
                  <TableCell>Email</TableCell>
                  {props.isGlobalSearch && <TableCell>Community</TableCell>}
                  
                  <TableCell>Unit</TableCell>
                  <TableCell>Bedroom</TableCell>
                  {!isNotImportDate && <TableCell>Import date</TableCell>}
                  <TableCell>Registered</TableCell>
                  <TableCell>Registration Date</TableCell>
                </TableRow>
              </TableHead>
              <UserSearchResultsTableBody
                users={props.results}
                isImportDate={!isNotImportDate}
                isGlobalSearch={props.isGlobalSearch}
              />
            </Table>
          </Grid>
        </Grid>
      )}
      {!props.results.length && <NoResults />}
    </>
  );
};
